import { Injectable, Output, EventEmitter  } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmitDataService {
  @Output() model: EventEmitter<any> = new EventEmitter();
  @Output() dataInput: EventEmitter<any> = new EventEmitter();
  @Output() paso: EventEmitter<any> = new EventEmitter();
  @Output() dato: EventEmitter<any> = new EventEmitter();
  @Output() datoBancario: EventEmitter<any> = new EventEmitter();
  @Output() valido: EventEmitter<any> = new EventEmitter();
  @Output() pagoCotizacion: EventEmitter<any> = new EventEmitter();

  constructor() { }

  enviarModel(model) {
    this.model.emit(model);
  }

  enviarDataInput(dataInput) {
    this.dataInput.emit(dataInput);
  }

  enviarPaso(paso) {
    this.paso.emit(paso);
  }

  enviarDato(dato) {
    this.dato.emit(dato);
  }

  enviarDatosBancarios(datoBancario) {
    this.datoBancario.emit(datoBancario);
  }

  enviarValidez(valido) {
    this.valido.emit(valido);
  }

  enviarPagoCotizacion(data) {
    this.pagoCotizacion.emit(data);
  }
}
